import { DateTime } from 'luxon';
import * as React from 'react';
import { Flex } from '../../designSystem/components/flex';
import { useCalendarContext } from './root';

interface IEventProps {
    children: React.ReactNode;
    startAt?: DateTime;
    endAt?: DateTime;
    startHour?: number;
}

export const Event = (props: IEventProps) => {
    const { days, interval } = useCalendarContext();
    const firstDay = days[0];
    const lastDay = days[6];
    const startAt = React.useMemo(
        () => (props.startAt ?? DateTime.max(firstDay, interval.start!)).startOf('day'),
        [props.startAt, firstDay, interval]
    );
    const endAt = React.useMemo(
        () => (props.endAt ?? DateTime.min(lastDay, interval.end!)).endOf('day'),
        [props.endAt, lastDay, interval]
    );
    const shouldOffsetStartHour = React.useMemo(
        () =>
            typeof props.startHour === 'number' &&
            props.startHour > 0 &&
            props.startAt?.isValid &&
            props.startAt.hour < props.startHour,
        [props.startAt, props.startHour]
    );
    const gridColumnStart = React.useMemo(() => {
        const start = Math.max(startAt.diff(firstDay, 'days').days + 1, 1);

        return shouldOffsetStartHour ? start - 1 : start;
    }, [shouldOffsetStartHour, startAt, firstDay]);
    const gridColumnEnd = React.useMemo(() => {
        const end = Math.min(Math.ceil(endAt.diff(firstDay, 'days').days) + 1, 8);

        return shouldOffsetStartHour ? end - 1 : end;
    }, [shouldOffsetStartHour, endAt, firstDay]);

    if (startAt > lastDay || endAt < firstDay) {
        return null;
    } else {
        return (
            <Flex
                css={{
                    gridColumnStart,
                    gridColumnEnd,
                    px: '$2'
                }}
            >
                {props.children}
            </Flex>
        );
    }
};
